import React from 'react';
import { API, View } from '@gin-betting/core';
import cn from 'classnames';
import cd from 'debug';

import { MarketTitle, VS } from 'components';
import globalMessages from 'messages';
import { AsyncOddButton } from 'modules/betslip/async';

import './MarketDefault.scss';

const debug = cd('match-list:components:MarketDefault');

interface Props {
    market?: View.Market;
    hasMatchHeader?: boolean;
    hasVS?: boolean;
    isDefaultName?: boolean;
}

export default class MarketDefault extends React.Component<Props> {
    static defaultProps: Required<Pick<Props, 'market'>> = {
        market: {
            id: '',
            priority: 0,
            status: API.MarketStatus.SUSPENDED,
            odds: ['', ''],
            name: '',
            specifiers: [],
            typeId: -999,
            tags: [],
        },
    };

    renderOdds = (): JSX.Element[] => {
        const { market, hasVS } = this.props;
        const { odds } = market || { odds: [] };

        const oddsComponents = odds.slice(0, 3).map((oddId, idx) => {
            return (
                <div
                    styleName={cn('button', {
                        'has-three-odds': odds.length > 2,
                    })}
                    key={oddId || idx}
                    className="__app-MarketDefault-button"
                >
                    <AsyncOddButton oddId={oddId} showResult={true} />
                </div>
            );
        });

        if (hasVS && oddsComponents.length === 2) {
            oddsComponents.splice(
                1,
                0,
                <div styleName="vs" key="vs" className="__app-MarketDefault-VS">
                    <VS />
                </div>
            );
        }

        return oddsComponents;
    };

    render() {
        debug('render', this.props);
        const { market, hasMatchHeader, isDefaultName } = this.props;

        return (
            <div
                styleName="container"
                className="__app-MarketDefault-container "
            >
                {hasMatchHeader && (
                    <MarketTitle
                        name={isDefaultName ? '' : market?.name ?? ''}
                        defaultMsg={globalMessages.marketWinner}
                    />
                )}
                {this.renderOdds()}
            </div>
        );
    }
}
